var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5891 1.07757C15.2637 0.752137 14.736 0.752137 14.4106 1.07757L6.07725 9.41091C5.92097 9.56719 5.83317 9.77915 5.83317 10.0002V13.3335C5.83317 13.7937 6.20627 14.1668 6.6665 14.1668H9.99984C10.2209 14.1668 10.4328 14.079 10.5891 13.9228L18.9224 5.58942C19.2479 5.26398 19.2479 4.73634 18.9224 4.41091L15.5891 1.07757ZM7.49984 12.5002V10.3453L14.9998 2.84534L17.1547 5.00016L9.65466 12.5002H7.49984ZM3.33317 4.16683C3.33317 3.70659 3.70627 3.3335 4.1665 3.3335H8.6165C9.07674 3.3335 9.44984 2.9604 9.44984 2.50016C9.44984 2.03993 9.07674 1.66683 8.6165 1.66683H4.1665C2.78579 1.66683 1.6665 2.78612 1.6665 4.16683V15.8335C1.6665 17.2142 2.78579 18.3335 4.1665 18.3335H15.8332C17.2139 18.3335 18.3332 17.2142 18.3332 15.8335V11.3835C18.3332 10.9233 17.9601 10.5502 17.4998 10.5502C17.0396 10.5502 16.6665 10.9233 16.6665 11.3835V15.8335C16.6665 16.2937 16.2934 16.6668 15.8332 16.6668H4.1665C3.70627 16.6668 3.33317 16.2937 3.33317 15.8335V4.16683Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d4827a8b.svg";
export { ForwardRef as ReactComponent };